module.exports = __webpack_public_path__ + "pc/img/work_detail4.4abd1040.jpg";